import { buildApiRequest } from 'utils/api';
import { urls } from 'utils/urls';

const urlHelper = {
  getVehiclesRequest: ({ opCode = '', isBroker = false } = {}) =>
    buildApiRequest('GET', isBroker ? urls.getBrokerVehicles : urls.getVehicles, { opCode }),

  updateVehicle: ({ payload, opCode, isBroker = false }) =>
    buildApiRequest('PUT', isBroker ? urls.updateBrokerVehicleAttr(opCode) : urls.updateVehicleAttr(opCode), payload),
  bulkUpdateVehicle: (payload) => buildApiRequest('PUT', urls.bulkVehicleUpdate, payload),
};

export default urlHelper;
